<div>
  <app-event-management-section-heading
    [id]="id"
    [title]="'event_form_location_title' | t"
    [description]="'event_form_location_title_description' | t"
  ></app-event-management-section-heading>
  <app-input-row
    [label]="'event_form_location' | t"
    [labelDescription]="'event_form_location_description' | t"
  >
    <app-location-autocomplete
      [fc]="innerForm.controls.event_location"
      [mapRef]="map"
    ></app-location-autocomplete>

    <app-checkbox
      [fc]="innerForm.controls.event_no_location"
      [label]="'event_form_no_location' | t"
    ></app-checkbox>
  </app-input-row>

  <app-google-map #map class="location__map"></app-google-map>
</div>
